import React from 'react';
import SecNavLink from './SecNavLinks';

import './SecondNav.css';

const SecondNav = () => {
    return (
        <main className='second-nav-container'>
            <div className='second-nav'>
                <SecNavLink />
            </div>  
        </main>
        
    )
}
export default SecondNav;